import { ReduxState } from '../../AppLoader/types';

export const selectMediaTypeSearchTabs = (state: ReduxState) =>
  state.mediaTypeSearch.tabs;

export const selectMediaTypeSearchBrowseText = (state: ReduxState) =>
  state.mediaTypeSearch.browseText;

export const selectMediaTypeSearchBrowseUrlArgs = (state: ReduxState) =>
  state.mediaTypeSearch.browseUrlArgs;

export const selectMediaTypeSearchShouldInvertControlsVisibility = (
  state: ReduxState
) => state.mediaTypeSearch.shouldInvertControlsVisibility;

export const selectMediaTypeSearchIsMember = (state: ReduxState) =>
  state.mediaTypeSearch.isMember;
